const placeholderAttr = 'data-placeholder'
const placeholderAttrSelector = `[${placeholderAttr}]`

export default function InsertPlaceholder (quill, text = '') {
	const currentPosition = quill.getSelection(true).index
	const [lineBlot] = quill.getLine(currentPosition)

	if (currentPosition === 0) {
		quill.root.classList.remove('ql-blank')
	}

	lineBlot.domNode.setAttribute(placeholderAttr, text)

	quill.once('text-change', () => {
		ClearPlaceholders(quill)
	})
}

function ClearPlaceholders (quill) {
	const allBlocks = quill.root.querySelectorAll(placeholderAttrSelector)
	allBlocks.forEach(el => el.removeAttribute(placeholderAttr))
}
